import { render, staticRenderFns } from "./componentBar.vue?vue&type=template&id=a032aee0&scoped=true"
import script from "./componentBar.vue?vue&type=script&lang=js"
export * from "./componentBar.vue?vue&type=script&lang=js"
import style0 from "./componentBar.vue?vue&type=style&index=0&id=a032aee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a032aee0",
  null
  
)

export default component.exports